import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import FeedbackPriceSection from '@/components/course/FeedbackPriceSection.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useSegment from '@/composables/useSegment'
  import useCourse from '@/composables/useCourse'
  import { useRoute } from 'vue-router/composables'
  import useShopifyClient from '@/composables/useShopifyClient'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PackagePriceSection',
  props: {
    productAmount: {
      type: Number,
      required: true,
    },
  },
  setup(__props) {

  const route = useRoute()
  const { arrowRight } = useIcons()
  const { coursePackagePurchaseIntended } = useSegment()
  const { courseBundle, packageId } = useCourse()
  const { createShopifyCheckout } = useShopifyClient()

  

  const inPackageInfoPage = computed(() => route.name === 'PackageDetails')

  const packagePurchased = computed(() => {
    return courseBundle.value?.courses?.every((course) => course.purchased) || false
  })

  const canUseShopifyCheckout = computed(() => !!courseBundle.value?.shopifyProductId)

  const packageCheckoutAction = async () => {
    await coursePackagePurchaseIntended(packageId.value, courseBundle.value!.title, 'package_details_page')
    await createShopifyCheckout()
  }

return { __sfc: true,route, arrowRight, coursePackagePurchaseIntended, courseBundle, packageId, createShopifyCheckout, inPackageInfoPage, packagePurchased, canUseShopifyCheckout, packageCheckoutAction, computed, FeedbackPriceSection, KetchUpButton, SVGRenderer, useIcons, useSegment, useCourse, useRoute, useShopifyClient }
}

})